// This person's look as a hook (issue 1445): the colour-blind-safe palette and the theme, read from the settings the
// shell holds, so a panel that draws an identity colour or a marker re-renders when the person ticks "Colour-blind-safe
// colours". The board's module-level look (`setLook` in board/tokenStatus.ts) is set by the shell in the same render;
// a panel drawn before the board once read the old palette there and kept it (the dice log in QA's run).
import { useMemo } from 'react';
import { displayColour, markerHex, type Marker } from '@dragons-table/vtt-shared';
import { useShell } from './context';

export function useLook(): { identity: (hex: string) => string; marker: (m: Marker) => string } {
  const { settings } = useShell();
  const palette = settings.palette ?? 'standard';
  const theme = settings.theme ?? 'dark';
  return useMemo(() => ({
    identity: (hex: string) => displayColour(hex, palette, theme),
    marker: (m: Marker) => markerHex(m, palette, theme),
  }), [palette, theme]);
}
